import Auth from '@/infrastructure/api/helper/Auth';
import download from '@/infrastructure/api/download';
import {在庫集計表出力条件型} from '@/type/custom/keiaikai/stock/在庫集計表出力条件型';

export default {
  async 在庫集計表をダウンロードする(出力条件: 在庫集計表出力条件型): Promise<void> {
    const auth = new Auth();
    const response = await auth.post('/api/aggregate/stock',
      出力条件,
      {
        responseType: 'blob',
      });
    const file = response.data;
    download.excelout(file, '在庫集計表.xlsx');
  },
};
